import { create } from 'zustand';

export type MessageItem = {
  id: number;
  title: string;
  type: 'info' | 'success' | 'danger' | 'warning';
  status?: 'active' | 'inactive' | 'removed';
};
type AddMessage = Omit<MessageItem, 'id'>;

type MessageStore = {
  messages: Array<MessageItem>;
  addMessage: (message: AddMessage) => void;
  showMessage: (id: number) => void;
  hideMessage: (id: number) => void;
  removeMessage: (id: number) => void;
};

export const useMessageStore = create<MessageStore>()((set) => ({
  messages: [
    // {
    //   id: 1,
    //   title: 'Test success message',
    //   type: 'success',
    // },
    // {
    //   id: 2,
    //   title: 'Test info message',
    //   type: 'info',
    // },
    // {
    //   id: 3,
    //   title: 'Test warning message',
    //   type: 'warning',
    // },
    // {
    //   id: 4,
    //   title: 'Test danger message',
    //   type: 'danger',
    // },
    // {
    //   id: 5,
    //   title: 'Test active message',
    //   type: 'success',
    //   status: 'active',
    // },
    // {
    //   id: 6,
    //   title: 'Test inactive message',
    //   type: 'success',
    //   status: 'inactive',
    // },
    // {
    //   id: 7,
    //   title: 'Test removed message',
    //   type: 'success',
    //   status: 'removed',
    // },
  ],
  addMessage: (message) =>
    set((state) => ({
      messages: [...state.messages, { id: state.messages.length + 1, ...message }],
    })),
  showMessage: (id) =>
    set((state) => ({
      messages: state.messages.map((msg) => (msg.id === id ? { ...msg, status: 'active' } : msg)),
    })),
  hideMessage: (id) =>
    set((state) => ({
      messages: state.messages.map((msg) => (msg.id === id ? { ...msg, status: 'inactive' } : msg)),
    })),
  removeMessage: (id) =>
    set((state) => ({
      messages: state.messages.map((msg) => (msg.id === id ? { ...msg, status: 'removed' } : msg)),
    })),
}));
